import { render } from "./CardChallengeLeaderboardFlank.vue?vue&type=template&id=50ce50f8&scoped=true"
import script from "./CardChallengeLeaderboardFlank.vue?vue&type=script&lang=js"
export * from "./CardChallengeLeaderboardFlank.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-leaderboard-flank.css?vue&type=style&index=0&id=50ce50f8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ce50f8"]])

export default __exports__